const AUTH_API = process.env.REACT_APP_AUTH_API_URL || "http://localhost:8001"

export async function deleteAccount() {
  const res = await fetch(`${AUTH_API}/api/auth/me`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  })
  return res.ok
}
